import { Command } from 'cmdk'

import { Flex, SearchIcon, Text } from '@buffer-mono/popcorn'

import styles from './CommandBar.module.css'

import type { JSX } from 'react'

/**
 * Props for the CommandBarEmpty component.
 */
interface CommandBarEmptyProps {
  /** Current search query to display in the empty state message */
  query?: string
}

export function CommandBarEmpty({ query }: CommandBarEmptyProps): JSX.Element {
  return (
    <Command.Empty className={styles.empty}>
      <Flex direction="column" align="center" gap="sm" justify="center">
        <SearchIcon size="large" color="subtle" />
        <Text color="subtle">
          {query
            ? `No results for "${query}". Try different keywords.`
            : 'Start typing to search...'}
        </Text>
      </Flex>
    </Command.Empty>
  )
}
